module.exports = __webpack_public_path__ + "static/media/mushroom.e4350914.png";